/**
 * Create an array that's filled with all numbers between start and end: (start, ..., end).
 */
export function range(start: number, end: number): number[] {
  return populateArray(end - start).map((x) => x + start);
}

/**
 * Create an array filled with a specified number of entries.
 * The entries will increment starting with zero (i.e. amount = 4 generates [0, 1, 2, 3]).
 */
export function populateArray(amount: number): number[] {
  return Array.from(Array(amount).keys());
}

/**
 * Returns a new array that doesn't contain the element at the given index
 * Implemented like this because splice cannot be used when given an immutable value (in JS a sealed or frozen object)
 */
export function removeIndexFromArray<T>(array: T[], index: number): T[] {
  const firstSlice = array.slice(0, index);
  const secondSlice = array.slice(index + 1);

  return firstSlice.concat(secondSlice);
}

/**
 * To be used in `Array.prototype.sort()` function to sort an array of elements by some element property.
 * @param key element's property name
 * @param reverse if the sorted result should be in reverse.
 */
export function compareArrayBy<T>(key: string, reverse?: boolean): (a: T, b: T) => number {
  return (a, b) => {
    const aValue = String(a[key]).toLowerCase();
    const bValue = String(b[key]).toLowerCase();
    const r = reverse ? 1 : -1;
    if (aValue > bValue) {
      return -1 * r;
    } else if (aValue < bValue) {
      return r;
    }
    return 0;
  };
}
